import axios from "axios";
import { Constants } from "../utils/Constants";

const baseUrl = Constants.baseUrl + "/notificacoes";

export const getContadorNaoLidas = () => {
  return axios.get(`${baseUrl}/contador-nao-lidas`);
}

export const getNotificacoes = (page = 1, per_page = 15) => {
  return axios.get(baseUrl, { params: { page, per_page } });
}

export const marcarComoLida = (id) => {
  return axios.patch(`${baseUrl}/${id}/lida`);
}
